module.exports = "<div id=\"search-component\">\n  <h4>Plan Search</h4>\n  <input #searchBox id=\"search-box\" autocomplete=\"off\" (keyup)=\"search(searchBox.value)\" />\n  <div>\n    <div *ngFor=\"let plan of plans | async\" (click)=\"gotoDetail(plan)\" class=\"search-result\" >\n      {{plan.name}}\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/plans/search/plan-search.component.html
// module id = 1126
// module chunks = 1